/* Majas – oändlig karusell (loopar runt och runt) */
function auto(el) {
  if (el.dataset.mmAutoReady) return;
  el.dataset.mmAutoReady = '1';

  const originals = Array.from(el.children);
  if (originals.length < 2) return;

  // Klona korten en gång så att slutet sitter ihop med början
  originals.forEach((c) => {
    const k = c.cloneNode(true);
    k.setAttribute('aria-hidden', 'true');
    k.inert = true;
    k.dataset.mmClone = '1';
    k.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
    el.appendChild(k);
  });
  const firstClone = el.children[originals.length];

  const setWidth = () => firstClone.getBoundingClientRect().left - originals[0].getBoundingClientRect().left;

  function wrap() {
    const w = setWidth();
    if (w <= 0) return;
    if (el.scrollLeft >= w - 2) {
      el.style.scrollSnapType = 'none';
      el.style.scrollBehavior = 'auto';
      el.scrollLeft = el.scrollLeft - w;
      requestAnimationFrame(() => { el.style.scrollSnapType = ''; el.style.scrollBehavior = ''; });
    }
  }

  let scrollT = null;
  el.addEventListener('scroll', () => {
    clearTimeout(scrollT);
    scrollT = setTimeout(wrap, 140);
  }, { passive: true });

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  const ms = Number(el.dataset.mmAutoplay) || 4000;
  let paused = false;
  let resumeT = null;
  const pause = () => { paused = true; clearTimeout(resumeT); };
  const resumeLater = (d) => { clearTimeout(resumeT); resumeT = setTimeout(() => { paused = false; }, d); };
  el.addEventListener('touchstart', pause, { passive: true });
  el.addEventListener('touchend', () => resumeLater(5000), { passive: true });
  el.addEventListener('mouseenter', pause);
  el.addEventListener('mouseleave', () => resumeLater(1500));
  el.addEventListener('focusin', pause);
  el.addEventListener('focusout', () => resumeLater(3000));

  setInterval(() => {
    if (paused || document.hidden) return;
    if (el.scrollWidth <= el.clientWidth + 4) return;
    const pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || 0;
    const box = el.getBoundingClientRect();
    const next = Array.from(el.children).find((c) => c.getBoundingClientRect().left - box.left - pad > 8);
    if (!next) return;
    el.scrollBy({ left: next.getBoundingClientRect().left - box.left - pad, behavior: 'smooth' });
  }, ms);
}

function initAll(root) {
  (root || document).querySelectorAll('[data-mm-autoplay]').forEach(auto);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
else initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
